import React, { ReactElement } from "react";
import { Button } from "@mui/material";

interface IModalFooter {
  children?: ReactElement;
}

const ModalFooter = (props: IModalFooter) => {
  const { children } = props;
  return (
    <div className="col-md-12  button-action-section d-flex">
      <div className="button-group d-flex">{children}</div>
    </div>
  );
};

export default ModalFooter;
